module.exports = __webpack_public_path__ + "static/img/lc1-2.45f653f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/lc1-2.png
// module id = 832
// module chunks = 0